import { Box, Grid, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import Category from './common/Category'

import category1 from '../../assets/categories/category1.png'
import category2 from '../../assets/categories/category2.png'
import category3 from '../../assets/categories/category3.png'
import category4 from '../../assets/categories/category4.png'
import { Link } from 'react-router-dom'
import useCategory from '../../Hook/useCategory'

function Categories() {
    const { categories, getCategories, loading } = useCategory()
    /* const [categories, setCategories] = useState([
        { id: 1, name: 'Category 1', image: category1 },
        { id: 2, name: 'Category 2', image: category2 },
        { id: 3, name: 'Category 3', image: category3 },
        { id: 4, name: 'Category 4', image: category4 },
    ]) */

    useEffect(() => {
        getCategories()
    }, [])
    return (
        <Box sx={{ width: '100%', py: 1 }}>
            <Box sx={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', mt: 1 }}>
                <Typography variant="h4" sx={{ my: 1 }}>Categories</Typography>
            </Box>
            <Grid container spacing={2}>
                {categories?.map((item, ind) => {
                    return (
                        <Grid item xs={12} sm={6} md={4} lg={3} key={ind} >
                            <Box sx={{ width: '100%', height: '300px', display: 'flex', alignItems: 'center', justifyContent: 'center', }} >
                                <Link to={`/Products`} style={{ textDecoration: 'none' }} ><Category item={item} /></Link>
                            </Box>
                        </Grid>
                    )
                })}
                {/* <Grid item xs={12} sm={6} md={4} lg={3} >
                    <Box sx={{ width: '100%', height: '300px', display: 'flex', alignItems: 'center', justifyContent: 'center', }}>
                        <Category />
                    </Box>
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3} >
                    <Box sx={{ width: '100%', height: '300px', display: 'flex', alignItems: 'center', justifyContent: 'center', }}>
                        <Category />
                    </Box>
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3} >
                    <Box sx={{ width: '100%', height: '300px', display: 'flex', alignItems: 'center', justifyContent: 'center', }}>
                        <Category />
                    </Box>
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3} >
                    <Box sx={{ width: '100%', height: '300px', display: 'flex', alignItems: 'center', justifyContent: 'center', }}>
                        <Category />
                    </Box>
                </Grid> */}

                {/* <Grid item xs={12} sm={6} md={4} lg={3}>

                    <Category />

                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3}>

                    <Category />

                </Grid> */}
            </Grid>
        </Box>
    )
}

export default Categories